import { useMutation } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Spinner
} from "reactstrap";
import OtherAssetsService from "src/modules/data-protection/apis/OtherAssetsService";

const ActivationModal = ({ t, isOpen, toggle, software, onUpdate }) => {
    const handleToggleSoftwareActivation = useMutation({
        mutationFn: async () => {
            const service = OtherAssetsService.getInstance();
            return await service.toggleActivation(software?.id);
        },
        onSuccess: () => {
            if (software?.is_inactive) {
                toast(t("Asset successfully activated."), {
                    type: "success"
                });
            } else {
                toast(t("Asset successfully deactivated."), {
                    type: "success"
                });
            }

            onUpdate && onUpdate();
            toggle();
        },
        onError: () => {
            if (software?.is_inactive) {
                toast(t("An error occurred while activating the asset."), {
                    type: "error"
                });
            }
            else {
                toast(t("An error occurred while deactivating the asset."), {
                    type: "error"
                });
            }
        }
    });

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
        >
            <ModalHeader
                toggle={toggle}
            >
                {t(software?.is_inactive ? 'Activate Asset' : 'Deactivate Asset')}
            </ModalHeader>

            <ModalBody>
                {software?.is_inactive ? (
                    <p>
                        {t('Are you sure you want to activate')} <strong>{software?.name}</strong>?
                    </p>
                ) : (
                    <p>
                        {t('Are you sure you want to deactivate')} <strong>{software?.name}</strong>?
                        <br />
                        <br/>
                        {t('Inactive asset will be automatically deleted after 3 years from the deactivation date.')}
                    </p>
                )}
            </ModalBody>

            <ModalFooter>
                <Button
                    color="secondary"
                    onClick={toggle}
                >
                    {t('Cancel')}
                </Button>
                <Button
                    color={software?.is_inactive ? 'success' : 'danger'}
                    onClick={handleToggleSoftwareActivation.mutate}
                    disabled={handleToggleSoftwareActivation.isLoading}
                >
                    {handleToggleSoftwareActivation.isLoading && (
                        <Spinner size="sm" className="me-2" /> 
                    )}

                    {t(software?.is_inactive ? 'Activate' : 'Deactivate')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    ActivationModal
);
